import { render, staticRenderFns } from "./HeaderBoxResume.vue?vue&type=template&id=6bd04ebc&"
import script from "./HeaderBoxResume.vue?vue&type=script&lang=js&"
export * from "./HeaderBoxResume.vue?vue&type=script&lang=js&"
import style0 from "./HeaderBoxResume.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports